import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function JobNew() {
  const { orgId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to jobs list page with modal open
    navigate(`/org/${orgId}/jobs?modal=new`, { replace: true });
  }, [navigate, orgId]);

  return null;
}
